import React from 'react';

import Typography from '../../library/typography/typography';
import StopwatchSolidIcon from '../../shared/icons/stopwatch-solid-icon';

import './product-promo-countdown.scss';

interface ProductPromoCountdownProps {
  countdownText: string;
}

function ProductPromoCountdown(props: ProductPromoCountdownProps) {
  const { countdownText } = props;

  return (
    <span className="product-promo-countdown" styleName="container">
      <StopwatchSolidIcon styleName="icon" />
      <Typography styleName="text" tag="span">
        Offer ends&nbsp;
        <time dateTime={countdownText} styleName="date">
          {countdownText}
        </time>
      </Typography>
    </span>
  );
}

export default ProductPromoCountdown;
